import { useState, useEffect, useCallback } from 'react';
import { listDomains } from 'services/DomainService';
import { DOMAIN_STATUS } from '../settings/domains/constants';

export function useDomainValidation() {
    const [hasValidatedDomain, setHasValidatedDomain] = useState(false);
    const [loading, setLoading] = useState(true);

    const fetchDomains = useCallback(() => {
        setLoading(true);
        return listDomains()
            .then((data) => {
                const hasAnyValidated = data.some(
                    (domain) => domain.status === DOMAIN_STATUS.RUNNING,
                );
                setHasValidatedDomain(hasAnyValidated);
                return { hasValidatedDomain: hasAnyValidated, domains: data };
            })
            .catch((error) => {
                console.error('Error fetching domains:', error);
                setHasValidatedDomain(false);
                return { hasValidatedDomain: false, domains: [] };
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    useEffect(() => {
        fetchDomains();
    }, [fetchDomains]);

    const refresh = useCallback(() => {
        return fetchDomains();
    }, [fetchDomains]);

    return { hasValidatedDomain, loading, refresh };
}
